import { IconButton, Typography } from '@material-ui/core';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import React, { useState } from 'react';
import { ReactElement } from 'react';
import { DialogWidth } from '../types';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    textAlign: 'center',
    paddingBottom: '20px',

    '& h1': {
      margin: 0,
      marginBottom: '0.5rem',
      fontSize: '1rem',
      fontWeight: 'normal',
    },
  },
  title: {
    textAlign: 'center',
    padding: '0px 32px',
    whiteSpace: 'pre-line',
    lineHeight: '115%',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey['900'],
  },
}));

interface Props {
  isOpen?: boolean;
  renderButton: any;
  renderContent: any;
  title?: string | ReactElement;
  closable?: boolean;
  onClose?: any;
  width?: DialogWidth;
}

const Dialog: React.FC<Props> = ({
  isOpen,
  renderButton,
  renderContent,
  title,
  closable = true,
  onClose = () => null,
  width = DialogWidth.DEFAULT,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleClose = () => {
    if (closable) {
      setOpen(false);
      onClose();
    }
  };

  const disableBackDropClick = (closeAction: () => void) => (_: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason !== 'backdropClick') {
      closeAction();
    }
  };

  return (
    <>
      {renderButton && renderButton(() => setOpen(true))}
      <MuiDialog
        open={open || !!isOpen}
        onClose={disableBackDropClick(handleClose)}
        maxWidth={width}
        fullWidth={true}
        {...props}
      >
        <MuiDialogTitle disableTypography>
          {title && (
            <Typography variant="h2" className={classes.title}>
              {title}
            </Typography>
          )}
          {closable && (
            <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
              <Close />
            </IconButton>
          )}
        </MuiDialogTitle>
        <MuiDialogContent className={classes.wrapper}>{renderContent(() => setOpen(false))}</MuiDialogContent>
      </MuiDialog>
    </>
  );
};
export default Dialog;
